import { Injectable } from '@angular/core';
import { Site } from '../models/Site.model';

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  private _site: Site = new Site();
  private _token: string = '';

  constructor() {}

  // * Return true if loggin is required
  setSiteData(data: any): boolean {
    this.cleanSession();

    this.site = data;

    if (this.site.password) {
      return true;
    }

    return false;
  }

  public get site(): Site {
    return this._site;
  }

  public set site(value: Site) {
    this._site = value;
  }

  public get token(): string {
    return this._token;
  }

  public set token(value: string) {
    this._token = value;
  }

  isAuthorized(): boolean {
    if (this._site.password) {
      return this.token.length > 0;
    }

    return true;
  }

  cleanSession() {
    this._site = new Site();
    this.token = '';
  }
}
